// shadowVisibility — when should the shared shadow-catcher plane be mounted?
//
// Splats can't receive shadow maps, so a single ShadowMaterial plane fakes
// ground shadows for every caster in the scene (the directional "sun" and the
// spotlight). The plane is decoupled from any one light: it shows up whenever
// *some* light is casting and the catcher isn't fully transparent. Each light's
// own enable flag controls whether ITS shadow lands on the plane (a disabled
// light simply isn't in the scene to cast). Pure so it's unit-testable.
export function shouldShowShadowCatcher({ shadowEnabled, shadowOpacity, spotlightEnabled }) {
  return shadowOpacity > 0 && (!!shadowEnabled || !!spotlightEnabled)
}
